import {Property} from './property.models';

export class SelectedProperty {
    pitem: Property;    // ID struttura selezionata
    ptype?: any;        // Property Type
    rtype?: any;        // Resource Type
    cfg?: any;          // Configuration Type
}
